import axios from "axios";
import store from "./index";
// import router from "../router";

export default {
  namespaced: true,

  state: {
    userData: null
  },

  getters: {
    user: state => state.userData
  },

  mutations: {
    setUserData(state, user) {
      state.userData = user;
    },
    setLanguageFromUser(state, user) {
      // Nastaviť jazyk podľa používateľského nastavenia z API
      // Podporuje obe štruktúry: user.pouzivatel.language (z /user endpoint) a user.language (z login endpoint)
      // Jazyk z API má prednosť pred localStorage
      let userLanguage = null;
      if (user && user.pouzivatel && user.pouzivatel.language) {
        userLanguage = user.pouzivatel.language;
      } else if (user && user.language) {
        userLanguage = user.language;
      }
      
      if (userLanguage) {
        // Overiť, či je jazyk v zozname dostupných jazykov
        const availableLanguages = store.state.countryList.map(lang => lang.code);
        if (availableLanguages.includes(userLanguage)) {
          // Použiť toggleLocale mutáciu, ktorá nastaví jazyk lokálne (bez volania API)
          store.commit('toggleLocale', userLanguage);
        }
      }
    }
  },

  actions: {
    getUserData({ commit, state }) {
      // Ak už máme userData, vráť ho hneď
      if (state.userData) {
        return Promise.resolve(state.userData);
      }
      // Inak načítaj z API
      return axios
        .get("user")
        .then(response => {
          commit("setUserData", response.data);
          // Nastaviť jazyk z API po načítaní dát používateľa
          commit("setLanguageFromUser", response.data);
          return response.data;
        })
        .catch(() => {
          // localStorage.removeItem("authToken");
          return null;
        });
    },
    sendLoginRequest({ commit }, data) {
      commit("setErrors", {}, { root: true });
      return new Promise(() => {
        axios.post("login", data)
            .then(response => {
              commit("setUserData", response.data.user);
              // Nastaviť jazyk z API len pri prihlásení
              commit("setLanguageFromUser", response.data.user);
              localStorage.setItem("authToken", response.data.token);
              // router.push({ name: "protokoly" });
                window.location.reload()
              this._vm.$toast.info(response.data.message);
              console.clear()
            }).catch(() => {
              store.dispatch('loader/done');
        })

      })

    },
    sendRegisterRequest({ commit }, data) {
      commit("setErrors", {}, { root: true });
      return axios
        .post("register", data)
        .then(response => {
          commit("setUserData", response.data.user);
          localStorage.setItem("authToken", response.data.token);
        });
    },
    sendLogoutRequest({ commit }) {
      return new Promise(() => {
        axios.post("logout")
            .then((response) => {
              commit("setUserData", null);
              localStorage.removeItem("authToken");
              // router.push({ name: "Login" });
                window.location.reload()
              this._vm.$toast.info(response.data.message);
            }).catch(() => {
            store.dispatch('loader/done');
        })

      })
    },
  }
};
